/**
 * Automation Skill Area
 * Lessons focused on identifying and implementing automation opportunities
 */

export { automationSpotlight } from './automation-spotlight';

import { automationSpotlight } from './automation-spotlight';
import type { LessonDefinition } from '../types';

export const automationLessons: LessonDefinition[] = [
  automationSpotlight,
];
